import {generateRainFloodExcel} from "./ApiCalls";
import {Button, Dialog, Label, Pane, TextInput, TextInputField, toaster} from "evergreen-ui";
import React from "react";
import {generateExcelViaTemplateId} from "../decadeConstructor/ApiCalls";
import SmartButton from "../common/SmartButton";
import SuspenseSpinner from "../../../Utils/SuspenseSpinner";
import {onDownloadFileAction} from "../common/OutputFormsDownloadFileFromConstructor";
import {getDefaultNameExactToDays, setEndDate, setEndTime, setStartTime} from "../common/DateMethods";
import {MAX_OUTPUT_FORM_NAME_LENGTH} from "../common/OutputFormsConstraints";

export default function CreateOutputFormRainFloodDialog({constructor, isShown, setIsShown, viaTemplateId= false, id, name}) {

    let [stationName, setStationName] = React.useState("")

    let [outputFormName, setOutputFormName] = React.useState(stationName)
    let [isOutputFormNameCustom, setIsOutputFormNameCustom] = React.useState(false)

    let [startPeriod, setStartPeriod] = React.useState("")
    let [endPeriod, setEndPeriod] = React.useState("")

    const [isFetch, setIsFetch] = React.useState(false)

    function updateStationName() {
        setStationName(
            name !== undefined ?
                name !== "" ?
                    name :
                    checkConstructor
                : checkConstructor
        )
    }

    function checkConstructor() {
        return constructor.station.name !== undefined ?
            constructor.station.name !== "" ?
                constructor.station.name :
                ""
            : ""
    }


    function clearDialogFields() {
        setOutputFormName('')
        setStartPeriod('')
        setEndPeriod('')
        setIsOutputFormNameCustom(false)
    }

    function createOutputForm() {
        const period = {
            start: startPeriod,
            end: endPeriod
        }

        if (outputFormName.length > MAX_OUTPUT_FORM_NAME_LENGTH) {
            toaster.danger("Ошибка! Наименование выходной формы не может быть длиннее " + MAX_OUTPUT_FORM_NAME_LENGTH
                +  " символов!")
            setIsFetch(false)
            return;
        }

        setIsFetch(true)
        if (viaTemplateId) {
            generateExcelViaTemplateId(id, period, outputFormName).then(() => {
                toaster.success('Файл сохранён!')
                setIsFetch(false)
                clearDialogFields()
            }).catch(() => {
                toaster.danger("Ошибка!")
                setIsFetch(false)
                clearDialogFields()
            })
        } else {
            generateRainFloodExcel(period, constructor, outputFormName).then((response) => {
                toaster.success('Файл сохранён!')
                clearDialogFields()
                setIsFetch(false)
                //скачиваем форму сразу
                onDownloadFileAction(response.data.id)
            })
            .catch(() => {
                toaster.danger("Ошибка!")
                setIsFetch(false)
                clearDialogFields()
            })
        }
    }

    function isFormButtonDisabled() {
        const start = new Date(startPeriod)
        const end = new Date(endPeriod)
        const dateIncorrect =  startPeriod === "" || endPeriod === "" || start - end > 0

        return outputFormName.trim().length === 0 || dateIncorrect
    }

    function setCustomOutputFormName(name) {
        setIsOutputFormNameCustom(true)
        setOutputFormName(name)
    }

    function getDefaultOutputFormName(stationName, startTime, endTIme) {
        if (isOutputFormNameCustom) {
            return outputFormName
        }

        return getDefaultNameExactToDays(stationName, startTime, endTIme)
    }

    function setStartDateWithFormNameSaving(value) {
        updateStationName()
        setStartPeriod(setStartTime(value))

        if (!isOutputFormNameCustom) {
            setOutputFormName(
                getDefaultNameExactToDays(
                    stationName,
                    setStartTime(value),
                    endPeriod
                ))
        }
    }

    function setEndDateWithFormNameSaving(value) {
        updateStationName()
        setEndPeriod(setEndTime(value))

        if (!isOutputFormNameCustom) {
            setOutputFormName(
                getDefaultNameExactToDays(
                    stationName,
                    startPeriod,
                    setEndTime(value)
                ))
        }
    }


    return (
        <Dialog
            isShown={isShown}
            title="Формирование выходной формы"
            onOpenComplete={() => {
                setOutputFormName(
                    getDefaultNameExactToDays(
                        stationName,
                        startPeriod,
                        endPeriod
                ))
            }}
            onCloseComplete={() => {
                clearDialogFields()
                setIsShown(false)
            }}
            footer={
                <Pane>
                    <Button marginRight={5} onClick={() => setIsShown(false)}>Отменить</Button>
                    <SmartButton
                        disabledTooltip={"Заполните все поля формы"}
                        buttonText={"Сформировать"}
                        isPrimary={true}
                        isDisabled={isFormButtonDisabled()}
                        onClickAction={() => createOutputForm()}
                    />
                </Pane>
            }

        >
            {isFetch ? <SuspenseSpinner/> : <Pane>
                <Pane display={"flex"} columnGap={10} marginBottom={15}>
                    <Pane width={250}>
                        <Label>Выберите дату начала паводка</Label>
                    </Pane>

                    <Pane>
                        <TextInput
                            width={155}
                            type="date"
                            name="startDate"
                            max={endPeriod}
                            onChange={val => {
                                setStartDateWithFormNameSaving(val.target.value)
                            }}
                        />
                    </Pane>
                </Pane>
                <Pane display={"flex"} columnGap={10} marginBottom={15}>
                    <Pane width={250}>
                        <Label>Выберите дату окончания паводка</Label>
                    </Pane>

                    <Pane>
                        <TextInput
                            width={155}
                            type="date"
                            name="endDate"
                            min={startPeriod}
                            onChange={val => {
                                setEndDateWithFormNameSaving(val.target.value)
                            }}
                        />
                    </Pane>
                </Pane>
                <Pane marginRight={30} marginTop={30}>
                    <TextInputField
                        label="Введите наименование выходной формы"
                        width={415}
                        value={
                            getDefaultOutputFormName(
                                stationName,
                                startPeriod,
                                endPeriod
                            )}
                        onChange={e => setCustomOutputFormName(e.target.value)}
                    />
                </Pane>
            </Pane>}
        </Dialog>
    )
}